import {SharedModule} from 'src/app/shared/shared.module';
import {LoginComponent} from './components';
import { FormsModule, ReactiveFormsModule  } from '@angular/forms'; 
import { HttpClientModule } from '@angular/common/http';  // Importa HttpClientModule

export const COMPONENTS = [
    LoginComponent
];

export const IMPORTS = [
  SharedModule,
  FormsModule,
  ReactiveFormsModule,
  HttpClientModule
];

export const SERVICES = [];

export const EXPORTS = [];
